export * from "./lib/slider";
export * from "./lib/device";
export * from "./lib/date";
export * from "./lib/routes";
export * from "./cors.js";

export const APP_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT;
export const IS_PRODUCTION = APP_ENV === "production";

export const EASTERN_TIMEZONE = "est";

export const CANADA_ISO = "CA";
export const US_ISO = "US";
export const DEFAULT_COUNTRY_ISO = US_ISO;
export const DEFAULT_CURRENCY_CODE = "USD";
export const RICH_RESULT_TYPES = {
  FAQ: "faq",
  BREAD_CRUMB: "breadCrumbStructure",
};
export const hubspotForms = {
  region: "na1",
  portalId: process.env.REACT_APP_HUBSPOT_PORTAL_ID || process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID,
};
export const TEAM_ALT_IMG_HOVER_DELAY = 0;
export const PLATFORM = {
  SNACKMAGIC: "Snackmagic",
  SWAGMAGIC: "SwagMagic",
  DSD: "Superior Dishes",
};
export const baseCountryLanguage = "en";

export const STADIUM_WAREHOUSE_ADDRESS = {
  line1: "42-38 13th Street",
  line2: "Long Island City",
  city: "New York",
  state: "NY",
  zip: "11101",
  phoneNum: "+1-888-646-6883",
  countryName: "United States",
};

export const SM_PROGRAM_IDENTIFIER = "snacks";
export const SM_PROGRAM_ID = 2;

export const NON_INTERNATIONAL_COUNTRIES_ISO = [CANADA_ISO, US_ISO];

export const DEFAULT_MAIL_HANDLER = "hi@bystadium.com";

export const AUTOMATION_EMAILS = [
  "automation@snackmagic.com",
  "dheerajgarg121@gmail.com",
  "automation+1@snackmagic.com",
];

export const weglotNoTranslationClassName = "no-translation";

export const SERVER_PHASE = typeof window === "undefined";

export const REMOVE_TRAILING_SLASH_REGEX = /\/$/;

export const REACT_PROJECT_TYPE = "react";

export const IS_REACT_PROJECT_TYPE = process.env.PROJECT_APP_TYPE === REACT_PROJECT_TYPE;

export const OPEN_ORDER_PREFIX_KEY = "open-order";

export const USER_DEPENDENT_PREFIX_KEY = "user-dependent";

export const FOOTER_PROPS = {
  bannerText: "GLOBAL GROUP GIFTING, REWARDS & SWAG",
  leftNavEnabledBannerText: "GROUP GIFTING, REWARDS AND SWAG",
  accessibilityEnabled: true,
};

export const MY_WORKSPACE_SLUG = "my-space";

export const INVITE_TOKEN_UUID_SEPERATOR = "--";

export const WORKSPACE_SLUG_REQUEST_HEADER_KEY = "x-workspace";
export const DEFAULT_WORKSPACE_SLUG = "default";
export const DEFAULT_WORKSPACE_ROUTE = `/${DEFAULT_WORKSPACE_SLUG}`;

export const SHOPS = "shops";
export const DASHBOARD = "dashboard";
export const SNACKMAGIC = "snackmagic";
export const SWAGMAGIC = "swagmagic";

export const APPLICATIONS = [SHOPS, DASHBOARD, SNACKMAGIC, SWAGMAGIC];

export const MAINTENANCE_PAGE_FLAG_OFF_REDIRECTION = {
  dashboard: "https://bystadium.com",
  shops: "https://bystadium.com",
  snackmagic: "https://snackmagic.com",
  swagmagic: "https://swagmagic.com",
};
